import React from "react";
import { t } from "../i18n";
import { SiFormError } from "./SiFormError";
import { If } from "./If";

export class SiInput extends React.Component<{
  className?: string;
  type?: string;
  label?: string;
  showLabel?: boolean;
  name?: string;
  placeholder?: string;
  required?: boolean;
  errors?: string[];
  value?: string | number | null;
  size?: string;
  icon?: string;
  min?: number;
  max?: number;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}> {
  get classes(): string {
    let classes = this.props.className || "";

    if (this.props.errors && this.props.errors.length) classes += " error";
    if (this.props.size === "large") classes += " large";

    return classes;
  }

  render(): React.ReactNode {
    const {
      type = "text",
      label = "",
      showLabel = true,
      name = "",
      placeholder = "",
      required = false,
      errors = null,
      value = "",
      icon = null,
      min = undefined,
      max = undefined,
      disabled = false,
      onChange
    } = this.props;

    return (
      <si-input>
        <If predicate={label !== "" && showLabel}>
          <label>{t(label)}</label>
        </If>

        <input
          disabled={disabled}
          type={type}
          name={name}
          placeholder={t(placeholder)}
          required={required}
          value={value ? value : ""}
          min={min}
          max={max}
          className={this.classes}
          onChange={onChange}
        />

        {errors ? <SiFormError errors={errors} /> : null}

        {icon ? <i className="material-icons">{icon}</i> : null}
      </si-input>
    );
  }
}
